<div class="small text-muted" *ngIf="contract?.observations">
  <b>{{ 'GLOBAL.OBSERVATIONS'|translate }}:</b>
  {{ contract.observations }}
</div>
<p *ngIf="contract">
  <span class="material-symbols-rounded text-warning">local_shipping</span>&nbsp;<span [innerHtml]="'SLOTS.PENDING_VOLUME'|translate: {
    pending: contract.quantity.value - (contract.applied.value || 0) | number:'1.0-2':currentLang,
    unit: contract.quantity.unit.abbrev
  }"></span>&nbsp;<span class="small text-warning" *ngIf="contract.price.type == 'to_be_fixed' &&
    contract.summary.fixed_volume?.value > 0" [innerHtml]="'SLOTS.PENDING_VOLUME_FIXED'|translate: {
    pending: contract.summary.fixed_volume.value - (contract.applied.value || 0) | number:'1.0-2':currentLang,
    unit: contract.quantity.unit.abbrev
  }"></span>
</p>